/**
 * Registry of all legal pages. Single source of truth shared by:
 *  - Footer (renders visible pages in the "Legal" column)
 *  - AdminLayout (CMS sidebar groups them under "Legal")
 *  - PreviewModal (maps page_key -> /legal/{slug})
 *  - LegalPage (renders content for any slug)
 *
 * Visibility is per-page, toggled from the back-office via legal.{slug}.visible.
 */
export const LEGAL_PAGES = [
  { slug: "acceptable-use",    shortLabel: "Acceptable Use",     title: "Acceptable Use & Prohibited Businesses Policy" },
  { slug: "aml-statement",     shortLabel: "AML Statement",      title: "Anti-Money Laundering & Compliance Statement" },
  { slug: "aml-ctf-policy",    shortLabel: "AML & CTF Policy",   title: "Anti-Money Laundering & Counter-Terrorist Financing Policy" },
  { slug: "complaints",        shortLabel: "Complaints",         title: "Complaints Handling Policy" },
  { slug: "cookie-policy",     shortLabel: "Cookie Policy",      title: "Cookie Policy" },
  { slug: "dpa",               shortLabel: "Data Processing",    title: "Data Processing Addendum" },
  { slug: "licences",          shortLabel: "Licences",           title: "Licences & Regulatory Disclosures" },
  { slug: "merchant-terms",    shortLabel: "Merchant Terms",     title: "Merchant Terms of Service" },
  { slug: "privacy",           shortLabel: "Privacy",            title: "Privacy Policy" },
  { slug: "regulatory-notice", shortLabel: "Regulatory Notice",  title: "Regulatory Notice" },
  { slug: "risk-framework",    shortLabel: "Risk Framework",     title: "Risk Management Framework" },
  { slug: "safeguarding",      shortLabel: "Safeguarding",       title: "Safeguarding and Client Funds Handling Policy" },
  { slug: "sanctions",         shortLabel: "Sanctions",          title: "Sanctions Compliance Statement" },
  { slug: "terms",             shortLabel: "Terms of Use",       title: "Website Terms of Use" },
];

export const legalPathFor = (slug) => `/legal/${slug}`;
